/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import {Button, Group, Input, Label, NumberField} from 'react-aria-components';
import React from 'react';

export default {
  title: 'React Aria Components'
};

export const NumberFieldExample = {
  args: {
    defaultValue: 0,
    minValue: 0,
    maxValue: 100,
    step: 1,
    formatOptions: {style: 'currency', currency: 'USD'},
    isWheelDisabled: false
  },
  render: (args) => (
    <NumberField {...args}>
      <Label>Test</Label>
      <Group style={{display: 'flex'}}>
        <Button slot="decrement">-</Button>
        <Input />
        <Button slot="increment">+</Button>
      </Group>
    </NumberField>
  )
};
